export default {
  inheritAttrs: false,
  name: "AppInput",

  data() {
    return {
      hovering: false,
      focused: false,
      isOnComposition: false
    };
  },

  props: {
    value: [String, Number, Date],
    size: {
      type: String,
      validator: value => ["", "standart", "small", "large"].includes(value)
    },
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    label: String,
    maxLength: Number,
    autoheight: Boolean,
    theme: {
      type: String,
      default: "main",
      validator: value => ["main", "second", "third", "fourth"].includes(value)
    },
    type: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    tabindex: String,
    inputStyles: Object,
    revertRestricted: {
      type: Boolean,
      default: true
    },
    inputClasses: {
      type: [String, Array, Object],
      default: ""
    },
    min: [Number, String],
    max: [Number, String],
    invalid: Boolean
  },

  computed: {
    inputDisabled() {
      return this.disabled;
    },
    numberMax() {
      return +this.max;
    },
    hasMax() {
      return !!this.numberMax || this.numberMax === 0;
    },
    length() {
      return this.maxLength - this.value.length;
    },
    classObj() {
      return {
        [`app-input_theme_${this.theme}`]: !!this.theme,
        [`app-input_size_${this.size}`]: !!this.size,
        "app-input_invalid": this.invalid,
        "app-input_autoheight": this.autoheight,
        "app-input_disabled": this.disabled
      };
    }
  },

  watch: {
    value: "calcHeight"
  },

  created() {
    this.$on("inputSelect", this.select);
  },

  mounted() {
    this.calcHeight();
  },

  methods: {
    focus() {
      this.getInput().focus();
    },
    blur() {
      this.getInput().blur();
    },
    handleBlur(event) {
      this.focused = false;
      this.$emit("blur", event);
    },
    select() {
      this.getInput().select();
    },
    handleFocus(event) {
      this.focused = true;
      this.$emit("focus", event);
    },
    handleComposition(event) {
      if (event.type === "compositionstart") {
        this.isOnComposition = true;
      }
      if (event.type === "compositionend") {
        this.isOnComposition = false;
        this.handleInput(event);
      }
    },
    handleInput(event) {
      if (this.isOnComposition) return;

      let { value } = event.target;
      if (this.hasMax && value > this.numberMax) value = this.numberMax;

      this.$emit("input", value);

      if (!this.revertRestricted) return;
      // set input's value, in case parent refuses the change
      this.$nextTick(() => {
        let input = this.getInput();
        input.value = this.value;
      });
    },
    handleChange(event) {
      this.$emit("change", event.target.value);
    },
    getInput() {
      return this.$refs.input;
    },
    getRootInput() {
      return this.$refs["app-input"];
    },
    calcHeight() {
      if (!this.autoheight) return;
      const input = this.getInput();
      const rootInput = this.getRootInput();
      if (!input || !rootInput) return 0;

      this.$nextTick(() => {
        rootInput.style.height = "30px";
        rootInput.style.height = `${input.scrollHeight}px`;
      });
    }
  }
};
